import React from 'react';
import { Switch, Route } from 'react-router-dom';

import ActivateAccount from './ActivateAccount';
import ActivationFailed from './ActivationFailed';

const Signup = props => (
  <Switch>
    <Route
      path="/signup/activation-failed"
      render={props => <ActivationFailed {...props} />}
    />

    <Route
      path="/signup/pending-verification"
      render={() => (
        <div className="container">
          <div className="white-panel verifications">
            <h2>Thank You For Joining HoneyGuide!</h2>
            <p>
              <strong>A verification link has been sent to your email account</strong>
            </p>
            <p>
              Please click on the link that has been sent to your email account
              <br />
              to verify your email and continue the registration process.
            </p>
          </div>
        </div>
      )}
    />

    <Route
      path="/signup/activate/:token"
      render={props => <ActivateAccount {...props} />}
    />
  </Switch>
);

export default Signup;



// WEBPACK FOOTER //
// ./src/screens/Signup/Signup.jsx